import request from '@shop/frontend/web/js/api/request';
import { Modal } from '@shop/frontend/web/js/components/Modal';
import {translator} from "@shop/frontend/web/js/services/TranslatorService";

translator.getLanguages();

class BackendError extends Error {
	constructor(message) {
		super(message);
		this.name = 'BackendError';
	}
}

const modal = new Modal();

function copyURI(evt) {
	evt.preventDefault();
	const text = window.location.href;
	const dummy = document.createElement('input');
	document.body.appendChild(dummy);
	dummy.value = text;
	dummy.select();
	document.execCommand('copy');
	document.body.removeChild(dummy);
	alert(translator.t("main", "Link copied to clipboard"));
}

$('.container__hotseats').on('click', '.btn-share', copyURI);

function transformButtonToBookedButton($btn) {
	$btn.closest('.text-right').addClass('is-booked');
	$btn.text('В корзине');
	$btn.removeClass('buy');
	$btn.addClass('booked disabled');
}

$('.container__hotseats').on('click', '.buy', function() {
	const $this = $(this);
	const { bookingId, sid, eventId } = $this.data();
	const key = $('#keySearch').val();

	const data = {
		event_id: eventId,
		key,
		sid,
		...(bookingId && { hold_id: bookingId }),
	};

	request({
		url: '/hold-seats/add-to-cart',
		addCSRFToken: true,
		data,
	})
		.then((response) => {
			if (response.error === 1) {
				throw new BackendError(response.msg);
			}
			transformButtonToBookedButton($this);
			window.CartService.count += 1;
			window.CartService.updateCount();
		})
		.catch((error) => {
			if (error.name !== 'BackendError') {
				return modal.show('Ошибка добавления в корзину, попробуйте снова');
			}

			if (error.message.includes('Превышен лимит билетов в заказе')) {
				return modal.show('Вы превысили максимально допустимое количество мест для брони');
			}

			return modal.show(error.message);
		});
});

function search() {
	const key = $('#keySearch').val();
	const unitId = $('#unitIdSearch').val();

	const queryParams = new URLSearchParams(window.location.search);
	queryParams.set('key', key);
	if (unitId !== undefined) queryParams.set('unit_id', unitId);
	history.replaceState(null, null, `?${queryParams.toString()}`);

	request({
		url: '/hold-seats',
		addCSRFToken: true,
		type: 'GET',
		data: {
			key,
			unitId,
		},
	})
		.then((response) => {
			if (key !== '') $('.alert').remove();
			$('.events').hide().html(response.eventsSeats).fadeIn('slow');
		})
		.catch((response) => {
			console.log(response);
			alert(translator.t("main", "Search error, try again"));
		});
}

$('.btn-search').click(search);

$('#keySearch').keyup(function (event) {
	if (event.event.key === "Enter") {
		event.preventDefault();
		search();
	}
});

$('#clear-input').on('click', (e) => {
	const keySearchInput = $(e.currentTarget).siblings('#keySearch')[0];
	keySearchInput.value = '';
});
